<template>
  <v-container id="cuenta-corriente-resumen">
  <validation-observer v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(validateForm)">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="5">
              <v-row>
                <v-col cols="12" md="6" class="pt-0">
                  <v-card v-show="menu3" color="indigo">
                    <v-card-title class="white titulo pb-1 pt-1">
                      Saldo al {{fSaldoAl}}
                    </v-card-title>
                    <v-card-text class="white text--primary">
                      <div :class="saldo > 0 ? 'positivo pt-2' : 'negativo pt-2'">
                        {{simbolo}} {{saldo}}
                      </div>
                      <div class="subtitulo pt-1">
                        {{descripcion}}
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
                 <v-col cols="12" md="6" class="pt-0">
                  <v-card v-show="menu2" color="indigo">
                    <v-card-title class="white titulo pb-1 pt-1">
                      <span>Saldo final</span>
                      <span v-if="seteadoFechaHasta" style="margin-left: 2px;"> al {{ fSaldoFinal }} </span>
                    </v-card-title>
                    <v-card-text class="white text--primary">
                      <div :class="resumen > 0 ? 'positivo pt-2' : 'negativo pt-2'">
                        {{simbolo}} {{resumen}}
                      </div>
                      <div class="subtitulo pt-1">
                        {{descripcion}}
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" md="7">
              <v-row>
                <v-col cols="12" md="3">
                  <v-menu ref="fechaMin" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                    <template v-slot:activator="{ on }">
                      <validation-provider v-slot="{ errors }" name="fecha desde">
                        <v-text-field v-model="fMin" :error-messages="errors" color="gold" label="Fecha desde" readonly clearable v-on="on" />
                      </validation-provider>
                    </template>
                    <v-date-picker v-model="fMin" color="gold" landscape scrollable locale="es-419" no-title @input="menu1 = false" />
                  </v-menu>
                </v-col>
                 <v-col cols="12" md="3">
                   <v-menu ref="fechaMax" v-model="menufechahasta" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                    <template v-slot:activator="{ on }">
                      <validation-provider v-slot="{ errors }" name="fecha hasta">
                        <v-text-field v-model="fMax" :error-messages="errors" color="gold" label="Fecha hasta" readonly clearable v-on="on" />
                      </validation-provider>
                    </template>
                    <v-date-picker v-model="fMax" color="gold" landscape scrollable locale="es-419" no-title @input="menufechahasta = false" />
                  </v-menu>
                 </v-col>
                <v-col cols="12" md="4">
                  <validation-provider v-slot="{ errors }" name="moneda" rules="required">
                    <v-select v-model="moneda_id" color="gold" :error-messages="errors" label="Moneda" item-value="id" item-text="descripcion" :items="monedas" clearable>
                      <template v-slot:item="{ attrs, item, on }">
                        <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                          <v-list-item-content>
                            <v-list-item-title v-text="item.descripcion" />
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-select>
                  </validation-provider>
                </v-col>
                <v-col cols="12" md="2" class="mt-1">
                  <v-btn fab dark small color="indigo" type="submit">
                    <v-icon dark>
                      mdi-magnify
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-data-table
                :headers="headers"
                :items="pagos.data"
                :page-count="pagos.last_page"
                :page="pagos.current_page"
                :server-items-length="pagos.total"
                :sort-by="sortby"
                :sort-desc="sortdesc"
                :footer-props="{
                  itemsPerPageOptions: [10]
                }"
                @click:row="handleClick"
                @update:options="getData($event)"
              >
                <template #item="{ item }">
                  <tr>
                    <td class="text-start">
                      <div @click="handleClick(item)">
                        {{ item.fecha }}
                      </div>
                    </td>
                    <td class="text-center">
                      <div @click="handleClick(item)">
                        {{ item.detalle }}
                      </div>
                    </td>
                    <td class="text-end">
                      <div :class="item.monto < 0 ? 'negativo' : 'positivo'" @click="handleClick(item)">
                        {{item.monto}}
                      </div>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </form>
  </validation-observer>
    <v-row class="px-3">

    </v-row>
  </v-container>
</template>

<script>
  import dayjs from 'dayjs'
  import GeneradorPdfRecibojs from '../../mixins/generadorPdfRecibo'

  export default {

    name: 'CuentaCorrienteResumen',
    components: {

    },
    mixins: [GeneradorPdfRecibojs],
    data () {
      return {
        headers: [
          { text: 'Fecha', align: 'start', sortable: false, value: 'fecha' },
          { text: 'Detalle ', align: 'center', sortable: false, value: 'detalle' },
          { text: 'Monto ', align: 'end', sortable: false, value: 'monto' },
        ],
        op: {},
        sortby: ['fecha'],
        sortdesc: [true],
        monedas: [],
        pagos: [],
        resumen: '',
        saldo: '',
        // fechaSaldo: '',
        simbolo: '',
        descripcion: '',
        menu1: false,
        menu2: false,
        menu3: false,
        menufechahasta: false,
        seteadoFechaHasta: false,
        fMin: null,
        fMax: null,
        fSaldoFinal: null,
        fSaldoAl: null,
        jugador_id: '',
        moneda_id: undefined,
        urlparametrizada: '',
      }
    },

    computed: {
      moneda () {
        var moneda = this.monedas.find(m => m.id === this.moneda_id)
        return moneda
      },
    },

    created () {
      this.getMonedas()
    },

    methods: {

      handleClick (item) {
        if (item.recibo_id) {
          this.generarPdfRecibo(item.recibo_id)
        } else {
          this.generarPdfPago(item.pagos_id)
        }
      },

      getData (data) {
        this.op = data
        this.readDataFromAPI(data.page, data.sortBy, data.sortDesc)
      },

      getMonedas: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/moneda' }).then(response => {
          this.monedas = response
        })
      },

      getResumen: function (saldoFinal) {
        this.resumen = saldoFinal.saldo ? saldoFinal.saldo : 0
        this.simbolo = this.moneda ? this.moneda.simbolo : ''
        this.descripcion = this.moneda ? this.moneda.descripcion : ''
        this.menu2 = true
        if (this.fMax) {
          this.seteadoFechaHasta = true
          this.fSaldoFinal = saldoFinal.fecha
        } else {
          this.seteadoFechaHasta = false
        }
      },

      getSaldo: function (SaldoDesde) {
        if (SaldoDesde) {
          if (SaldoDesde.recibo_id) {
            this.saldo = SaldoDesde.saldo ? SaldoDesde.saldo - SaldoDesde.monto : 0
          } else {
            this.saldo = SaldoDesde.saldo ? SaldoDesde.saldo + SaldoDesde.monto : 0
          }
          this.menu3 = true
          this.fSaldoAl = SaldoDesde.fecha
        } else {
          const mensaje = 'No hay movimientos en el rango seleccionado ' + this.fMin + ' <--> ' + ((this.fMax) ? this.fMax : dayjs().format('YYYY-MM-DD'))
          this.$store.commit('toast/show', { tipo: 'success', messages: [mensaje] })
        }
      },
      getSaldos: function () {
        if (this.fMin && this.fMax) {
          const fechaD = dayjs(this.fMin)
          const fechaH = dayjs(this.fMax)
          if ((fechaD.isAfter(fechaH))) {
            this.$store.commit('toast/show', { tipo: 'success', messages: ['El rango seleccionado de fechas no es válido'] })
            return
          }
        }
        this.$store.dispatch('axiosMod/getData', { url: '/api/getSaldos/' + this.moneda_id + '?fDesde=' + this.fMin + '&fHasta=' + this.fMax }).then(response => {
          console.log('resultados: ')
          console.log(response)

          this.getResumen(response[1])
          this.getSaldo(response[0])
        })
      },

      readDataFromAPI: async function (page = 1, sortBy, sortDesc) {
        this.$store.dispatch('axiosMod/getData', {
          url: '/api/cuentaCorriente/' + this.moneda_id + '?page=' + page + '&fmin=' + this.fMin + '&fmax=' + this.fMax + '&sortBy=' + sortBy + '&sortDesc=' + sortDesc,
        }).then(response => {
          this.pagos = response
        })
      },

      validateForm (scope) {
        this.readDataFromAPI(1, this.sortby, this.sortdesc)
        this.getSaldos()
        // this.getResumen()
      },

    },
  }
</script>

<style>
  .titulo
  {
    font-size: 16px;
  }
  .subtitulo
  {
    font-size: 13px;
  }
  .positivo
  {
    color:rgb(0, 177, 106) !important;
    font-size: 16px !important;
  }
  .negativo
  {
    color:rgb(240, 52, 52) !important;
    font-size: 16px !important;
  }
</style>
